import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { useSetRecoilState } from "recoil";
import { BACKEND_URL } from "src/Atoms";
import { kakaoModalState } from "src/atoms/KakaoModalAtom";
import FullScreenSpinner from "src/components/FullScreenSpinner";

// 모바일에서 바로 이동할 카카오톡 채널 채팅 주소 (기존 useKakaoModal과 동일 값)
const KAKAO_CHAT_URL = "https://pf.kakao.com/_xbDexfG/chat";

/**
 * 블로그/카페 등 외부 유입을 위한 경유 라우트(/kakao).
 * - 유입 출처를 우리 DB에 직접 기록한다. (구글 애널리틱스 등 외부 추적 미사용)
 * - 매체는 단일 쿼리 파람 `s`로 받는다. 예) /kakao?s=naver-blog
 * - 모바일: 카카오톡 채널로 즉시 이동
 * - 데스크톱: 랜딩페이지로 이동하며 KakaoChannelGuideModal 자동 오픈
 */
export default function KakaoRedirect() {
  const navigate = useNavigate();
  const openKakaoModal = useSetRecoilState(kakaoModalState);

  useEffect(() => {
    // 어느 매체에서 왔는지 읽기 (없으면 direct)
    const source = new URLSearchParams(window.location.search).get("s") || "direct";

    // 백엔드에 유입 기록. 페이지를 곧바로 떠나도(모바일) 전송이 보장되어야 하므로
    // sendBeacon을 쓰고, 없는 구형 브라우저는 fetch(keepalive)로 폴백한다.
    // (IP는 서버에서 추출하므로 본문 없이 매체만 쿼리로 넘긴다.)
    const inflowUrl = `${BACKEND_URL}/apiOpen/b2c/inflow?s=${encodeURIComponent(source)}`;
    // sendBeacon은 큐가 차면 false를 반환할 수 있다. 없거나 실패하면 fetch(keepalive)로 폴백.
    const sent = navigator.sendBeacon?.(inflowUrl);
    if (!sent) {
      fetch(inflowUrl, { method: "POST", keepalive: true }).catch(() => {});
    }

    // 기기별 분기
    if (isMobile) {
      // 모바일: 카카오 채널로 즉시 이동
      window.location.href = KAKAO_CHAT_URL;
      return;
    }

    // 데스크톱: 안내 모달을 켠 상태로 랜딩페이지로 이동
    openKakaoModal(true);
    navigate("/", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 이동하는 짧은 순간 동안 빈 화면 대신 스피너
  return <FullScreenSpinner />;
}
